<template>
  <page
    :custom-style="{
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',
      minHeight: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <div class="mask"></div>
    <div
      v-if="!browerInfo.isMiniProgram"
      class="nav-gradient-mask"
      :style="{ height: pagePaddingTop }"
    ></div>
    <div v-if="hasLoad" class="member-saving-page">
      <maple-nav-bar
        v-if="!browerInfo.isMiniProgram"
        class="nav-bar"
        title="会员省钱"
        opacity-style
        left-arrow
        :safe-top-distance="statusBarHeight"
        :opacity="1"
        background="transparent"
        @click-left="goBack"
      >
        <template #right>
          <span class="buy-record" @click="goBuyList">购买记录</span>
        </template>
      </maple-nav-bar>
      <div v-else class="mini-nav">
        <span class="back" @click="goBack">‹</span>
        <span class="title">会员省钱</span>
        <span class="buy-record" @click="goBuyList">购买记录</span>
      </div>

      <empty
        v-if="isLoadFailed"
        class="saving-empty"
        :type="2"
        :has-btn="true"
        @clickBtn="getSavingDetail"
      />

      <template v-else>
        <van-pull-refresh
          v-model="isRefreshing"
          class="saving-refresh"
          @refresh="onRefresh"
        >
          <main class="content">
            <div :class="['tabs', { single: !isMember }]">
              <button
                v-if="isMember"
                :class="['tab', { active: activeTab === 'current' }]"
                @click="changeTab('current')"
              >
                本周期省钱
              </button>
              <button
                :class="['tab', { active: activeTab === 'cumulative' }]"
                @click="changeTab('cumulative')"
              >
                累计省钱
              </button>
            </div>

            <template v-if="activeTab === 'current' && currentPeriod">
              <section class="saving-card">
                <p class="card-label">累计节省</p>
                <p class="card-amount">
                  <span class="currency">¥</span
                  >{{ formatMoney(currentPeriod.savingAmount) }}
                </p>
                <p class="period">本周期{{ currentPeriod.startEndTime }}</p>
              </section>

              <section
                v-if="hasCurrentSavings && topProducts.length"
                class="panel"
              >
                <div class="panel-header">
                  <h2>省钱Top5商品</h2>
                </div>
                <div
                  v-for="(item, index) in topProducts"
                  :key="index"
                  class="rank-row"
                >
                  <span :class="['product-rank', `rank-${index + 1}`]">{{
                    index + 1
                  }}</span>
                  <span class="row-name">{{ item.biName }}</span>
                  <span class="row-amount"
                    ><i class="amount-currency">¥</i
                    >{{ formatMoney(item.savingAmount) }}</span
                  >
                </div>
              </section>

              <section
                v-if="hasCurrentSavings && leaderboard"
                class="panel leaderboard-panel"
              >
                <h2>{{ leaderboard.cityName }}会员省钱榜</h2>
                <template v-if="isLeaderboardUnlocked">
                  <p class="leaderboard-summary">
                    你位列第 <strong>{{ leaderboard.myRank }}</strong> 名
                  </p>
                  <div
                    v-for="(item, index) in leaderboard.rankList"
                    :key="`${item.rank}-${item.shopName}`"
                    class="leaderboard-row"
                  >
                    <div
                      v-if="item.rank === firstOtherRank"
                      class="other-ranks"
                    >
                      <span>其他排名</span>
                    </div>
                    <div
                      :class="[
                        'rank-row',
                        {
                          mine: item.isSelf === 1,
                          'no-divider': isBeforeSpecialRow(index)
                        }
                      ]"
                    >
                      <span
                        :class="['leaderboard-rank', `rank-${item.rank}`]"
                        >{{ item.rank }}</span
                      >
                      <span class="row-name">{{ item.shopName }}</span>
                      <span class="row-amount"
                        ><i class="amount-currency">¥</i
                        >{{ formatMoney(item.savingAmount) }}</span
                      >
                    </div>
                  </div>
                </template>
                <div v-else class="locked">
                  <div class="lock-icon"><i></i></div>
                  <p class="lock-title">待解锁</p>
                  <p class="unlock-text">
                    再省 ¥{{
                      formatMoney(leaderboard.unlockDiffAmount)
                    }}，解锁{{ leaderboard.cityName }}会员省钱榜
                  </p>
                  <p class="lock-tip">累计省钱满 ¥500 后自动参与排名</p>
                </div>
              </section>
            </template>

            <template v-else>
              <section class="saving-card cumulative-card">
                <p class="card-label">累计节省</p>
                <p class="card-amount">
                  <span class="currency">¥</span
                  >{{ formatMoney(cumulative.savingAmount) }}
                </p>
              </section>
              <section class="panel period-panel">
                <h2>各周期省钱明细</h2>
                <div class="period-head">
                  <span>周期</span><span>省钱金额</span>
                </div>
                <div
                  v-for="(item, index) in cumulative.periodList"
                  :key="index"
                  class="period-row"
                >
                  <span>{{ item.startEndTime }}</span>
                  <strong
                    ><i class="amount-currency">¥</i
                    >{{ formatMoney(item.savingAmount) }}</strong
                  >
                </div>
                <div v-if="!cumulative.periodList.length" class="empty-period">
                  暂无省钱明细
                </div>
              </section>
            </template>
          </main>
          <p v-if="dataAsOfDate" class="data-date">
            仅统计已完成订单，数据截至 {{ formatDate(dataAsOfDate) }}
          </p>
        </van-pull-refresh>
      </template>
    </div>
  </page>
</template>

<script>
import { API } from '@/api'
import { NavBar } from '@mc/mc-jsbridge'
import { PullRefresh } from 'vant'
import themeMixin from '@/common/mixins/theme'
import Empty from '@/common/layout/empty/index'

export default {
  name: 'McMemberSaving',
  components: {
    Empty,
    [PullRefresh.name]: PullRefresh
  },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = '会员省钱'
      vm.initNavigation()
      vm.getSavingDetail()
    })
  },
  data() {
    const isMember = this.$route.query.isMember === '1'
    return {
      browerInfo: window.matrix,
      hasLoad: false,
      isLoadFailed: false,
      isRefreshing: false,
      isMember,
      activeTab: isMember ? 'current' : 'cumulative',
      dataAsOfDate: '',
      currentPeriod: null,
      cumulative: { savingAmount: '0.00', periodList: [] }
    }
  },
  computed: {
    pagePaddingTop() {
      return this.browerInfo.isMiniProgram
        ? '0px'
        : `${44 + this.statusBarHeight}px`
    },
    topProducts() {
      return this.currentPeriod?.topGoodsList || []
    },
    hasCurrentSavings() {
      return Number(this.currentPeriod?.savingAmount || 0) > 0
    },
    leaderboard() {
      return this.currentPeriod?.ranking || null
    },
    isLeaderboardUnlocked() {
      return (
        this.leaderboard?.joinStatus === 1 &&
        Array.isArray(this.leaderboard.rankList) &&
        this.leaderboard.rankList.length > 0
      )
    },
    firstOtherRank() {
      const item = this.leaderboard?.rankList?.find(entry => entry.rank > 5)
      return item?.rank || 0
    }
  },
  activated() {
    this.initNavigation()
  },
  methods: {
    initNavigation() {
      if (!this.browerInfo.isMiniProgram) {
        const navBar = new NavBar(0)
        navBar.init()
      }
    },
    isBeforeSpecialRow(index) {
      const nextItem = this.leaderboard?.rankList?.[index + 1]
      return Boolean(
        nextItem &&
          (nextItem.rank === this.firstOtherRank || nextItem.isSelf === 1)
      )
    },
    async getSavingDetail() {
      this.isLoadFailed = false
      console.log('[member-saving] request start')
      try {
        const resData = await API.primeCard.primeCardSavingDetail()
        console.log('[member-saving] response data', resData)
        this.setSavingData(resData)
        console.log('[member-saving] render data', {
          isMember: this.isMember,
          activeTab: this.activeTab,
          currentPeriod: this.currentPeriod,
          total: this.cumulative
        })
      } catch (e) {
        // 便于在移动端调试工具定位请求层或页面处理异常。
        console.error('[member-saving] load failed', e)
        this.isLoadFailed = true
      } finally {
        this.hasLoad = true
      }
    },
    async onRefresh() {
      await this.getSavingDetail()
      this.isRefreshing = false
    },
    setSavingData(data) {
      if (!data) return
      this.dataAsOfDate = data.dataDate || ''
      const previousIsMember = this.isMember
      if (typeof data.payStatus === 'number') {
        this.isMember = data.payStatus === 1
      }
      this.currentPeriod = data.currentPeriod || null
      this.cumulative = data.total || {
        savingAmount: '0.00',
        periodList: []
      }
      if (!this.isMember || (this.isMember && !this.currentPeriod)) {
        this.activeTab = 'cumulative'
      } else if (!previousIsMember) {
        this.activeTab = 'current'
      }
    },
    changeTab(tab) {
      if (tab === this.activeTab) return
      this.activeTab = tab
      // 接口一次返回本周期与累计数据，切换时无需重复请求。
    },
    goBack() {
      this.$back()
    },
    goBuyList() {
      this.$router.push({ name: 'memberBuyList' })
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    },
    formatDate(value) {
      return String(value).replace(/-/g, '.')
    }
  }
}
</script>

<style scoped lang="scss">
.member-saving-page {
  position: relative;
  min-height: 100vh;

  color: #10275c;
  .nav-bar {
    position: fixed;
    top: 0;
    z-index: $z-navigation-bar + 1;

    width: 100%;
  }
  .buy-record {
    color: #262626;
    font-size: 0.26rem;
    font-weight: 500;
  }
  .mini-nav {
    display: flex;

    height: 0.88rem;
    padding: 0 0.24rem;

    align-items: center;
    justify-content: space-between;
    .back {
      width: 0.56rem;

      font-size: 0.68rem;
      line-height: 0.56rem;
    }
    .title {
      font-size: 0.38rem;
      font-weight: bold;
    }
  }
  .content {
    padding: 0.32rem 0.24rem 0;
  }
  .saving-refresh {
    // Vant 默认 overflow: hidden 会裁掉短内容页下移后的底部。仅裁切顶部，保留下方的刷新位移空间。
    overflow: visible;

    clip-path: inset(0 -100vmax -100vmax);
  }
  .tabs {
    display: flex;

    width: 4.48rem;
    height: 0.72rem;
    margin: 0 auto 0.28rem;
    padding: 0.02rem;

    border: 1px solid #e8d8d4;
    border-radius: 0.4rem;
    &.single {
      width: 2.26rem;
    }
    .tab {
      flex: 1;

      border: 0;
      border-radius: 0.36rem;
      background: transparent;
      color: #10275c;
      font-size: 0.3rem;
      &.active {
        background: linear-gradient(120deg, #082757, #183d79);
        color: #fff;
      }
    }
  }
  .saving-card {
    height: 2.7rem;
    margin-bottom: 0.28rem;
    padding: 0.42rem 0.4rem;
    box-sizing: border-box;

    background: radial-gradient(circle at 110% 90%, #ffd59f, transparent 46%),
      linear-gradient(120deg, #ffedca, #fff6e8);
    border-radius: 0.2rem;
  }
  .card-label,
  .period {
    margin: 0;

    color: #576783;
    font-size: 0.26rem;
  }
  .card-amount {
    display: flex;
    align-items: flex-end;
    margin: 0.22rem 0 0.12rem;

    color: #7d2707;
    font-size: 0.9rem;
    font-weight: bold;
    line-height: 1rem;
    .currency {
      margin-right: 0.04rem;

      font-size: 0.4rem;
      line-height: 1;
      transform: translateY(-0.12rem);
    }
  }
  .panel {
    margin-top: 0.28rem;
    padding: 0.22rem 0.3rem;

    background: #fff;
    border-radius: 0.2rem;
    box-shadow: 0 0.06rem 0.24rem rgba(25, 49, 91, 0.06);
    h2 {
      margin: 0;

      color: #08265d;
      font-size: 0.36rem;
      line-height: 0.56rem;
    }
  }
  .panel-header,
  .period-head,
  .period-row {
    display: flex;

    justify-content: space-between;
  }
  .panel-header span,
  .period-head {
    color: #71809b;
    font-size: 0.24rem;
  }
  .rank-row,
  .period-row {
    display: flex;

    min-height: 0.72rem;
    border-bottom: 1px solid #edf0f5;
    align-items: center;
    &:last-child {
      border-bottom: 0;
    }
  }
  .product-rank,
  .leaderboard-rank {
    display: inline-flex;

    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.16rem;

    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 0.25rem;
  }
  .product-rank {
    border-radius: 50%;
    background: #f7efe7;
    line-height: 0.4rem;
    &.rank-1 {
      background: #ffc343;
    }
    &.rank-2 {
      background: #e5e9ef;
    }
    &.rank-3 {
      background: #ffad72;
    }
  }
  .leaderboard-rank {
    position: relative;

    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.12rem;
    color: #65738e;
    isolation: isolate;
    &.rank-1,
    &.rank-2,
    &.rank-3 {
      border-radius: 50%;
      color: #fff;
      font-weight: bold;
      transform: translateY(-0.03rem);
      &::before,
      &:after {
        position: absolute;
        bottom: -0.1rem;

        width: 0.13rem;
        height: 0.14rem;
        z-index: -1;

        clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 78%, 0 100%);
        content: '';
      }
      &::before {
        left: 0.06rem;
        transform: rotate(14deg);
      }
      &::after {
        right: 0.06rem;
        transform: rotate(-14deg);
      }
    }
    &.rank-1 {
      background: radial-gradient(circle at 32% 26%, #ffeaa1, #f2af16 64%);
      color: #fff;
      box-shadow: 0 0.03rem 0.06rem rgba(202, 138, 12, 0.28);
      &:before,
      &:after {
        background: linear-gradient(#f6c241, #d7910c);
      }
    }
    &.rank-2 {
      background: radial-gradient(circle at 32% 26%, #f6f8fb, #abb7c6 64%);
      color: #fff;
      box-shadow: 0 0.03rem 0.06rem rgba(104, 119, 140, 0.22);
      &:before,
      &:after {
        background: linear-gradient(#cbd4df, #8f9dae);
      }
    }
    &.rank-3 {
      background: radial-gradient(circle at 32% 26%, #ffc49f, #e77d50 64%);
      color: #fff;
      box-shadow: 0 0.03rem 0.06rem rgba(175, 84, 46, 0.22);
      &:before,
      &:after {
        background: linear-gradient(#f1a278, #ca6541);
      }
    }
  }
  .row-name {
    overflow: hidden;

    flex: 1;

    font-size: 0.28rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row-amount,
  .period-row strong {
    color: #842a0c;
    font-size: 0.28rem;
    font-weight: bold;
    .amount-currency {
      margin-right: 0.02rem;

      font-size: 0.2rem;
      font-style: normal;
      vertical-align: 0.02rem;
    }
  }
  .leaderboard-summary {
    display: flex;

    margin: 0.16rem 0;

    color: #63728f;
    font-size: 0.25rem;
    align-items: center;
    strong {
      margin: 0 0.08rem;
      color: #8b2c0d;
      font-size: 0.36rem;
    }
    span {
      margin-left: auto;
    }
  }
  .mine {
    width: calc(100% + 0.32rem);
    min-height: 0.72rem;
    margin: 0.04rem -0.16rem;
    padding: 0 0.16rem;
    box-sizing: border-box;

    border: 0;
    border-radius: 0.08rem;
    background: #fff9ed;
    box-shadow: inset 0 0 0 1px #f3af37;
    font-weight: bold;
    .row-amount {
      font-weight: bold;
    }
  }
  .other-ranks {
    display: flex;

    height: 0.52rem;
    color: #7d89a0;
    font-size: 0.23rem;
    align-items: center;
    &::before,
    &::after {
      height: 1px;
      background: #edf0f5;
      content: '';
      flex: 1;
    }
    span {
      padding: 0 0.16rem;
    }
  }
  .leaderboard-panel {
    .leaderboard-row .rank-row:not(.mine) {
      border-bottom: 1px solid #edf0f5;
    }
    .leaderboard-row:last-child .rank-row {
      border-bottom: 0;
    }
    .leaderboard-row .rank-row.no-divider {
      border-bottom: 0;
    }
  }
  .locked {
    display: flex;

    min-height: 2.72rem;
    margin-top: 0.3rem;
    padding: 0.42rem 0.16rem 0.38rem;

    border: 1px solid #edf0f6;
    border-radius: 0.16rem;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  .lock-icon {
    position: relative;
    width: 0.52rem;
    height: 0.44rem;
    margin: 0.12rem auto 0.24rem;

    border: 0.04rem solid #d49a22;
    border-radius: 0.06rem;
    box-sizing: border-box;
    &::before {
      position: absolute;
      top: -0.3rem;
      left: 50%;

      width: 0.32rem;
      height: 0.3rem;
      border: 0.04rem solid #10275c;
      border-bottom: 0;
      border-radius: 0.16rem 0.16rem 0 0;
      box-sizing: border-box;
      content: '';
      transform: translateX(-50%);
    }
    i {
      position: absolute;
      top: 0.12rem;
      left: 50%;

      width: 0.06rem;
      height: 0.12rem;
      border-radius: 0.03rem;
      background: #10275c;
      transform: translateX(-50%);
    }
  }
  .lock-title {
    margin: 0 0 0.28rem;
    color: #5d6e8a;
    font-size: 0.32rem;
    line-height: 0.4rem;
  }
  .unlock-text {
    margin: 0;
    font-size: 0.28rem;
    font-weight: bold;
    line-height: 0.42rem;
  }
  .lock-tip {
    margin: 0.2rem 0 0;
    color: #72809a;
    font-size: 0.24rem;
    line-height: 0.34rem;
  }
  .period-head {
    margin-top: 0.24rem;
    padding-bottom: 0.16rem;

    border-bottom: 1px solid #edf0f5;
  }
  .period-row {
    color: #10275c;
    font-size: 0.28rem;
  }
  .empty-period {
    padding: 0.5rem 0 0.2rem;
    color: #8b96aa;
    font-size: 0.26rem;
    text-align: center;
  }
  .data-date {
    margin: 0;
    padding: 0.38rem 0 0.24rem;

    color: #74819b;
    font-size: 0.24rem;
    text-align: center;
  }
}
.nav-gradient-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar - 1;

  width: 100%;

  background-image: linear-gradient(180deg, #fff0df, #ffffff);
  background-repeat: no-repeat;
  background-size: 100% 4.92rem;
  pointer-events: none;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 4.92rem;

  background-image: linear-gradient(180deg, #fff0df, #ffffff);
}
</style>
